import { Modal, TextField, Button } from 'components/ds2'

interface TelegramGroupModalProps {
    open: boolean
    onClose: () => void
    groupName: string
    onGroupNameChange: (value: string) => void
    onSave: () => void
    isSaving: boolean
}

export const TelegramGroupModal = ({ open, onClose, groupName, onGroupNameChange, onSave, isSaving }: TelegramGroupModalProps) => {
    return (
        <Modal
            open={open}
            onClose={onClose}
            size="sm"
            header={<h3 className="text-xl font-semibold text-foreground">Edit Group Name</h3>}
            footer={
                <>
                    <Button variant="outline" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button onClick={onSave} loading={isSaving}>
                        Save
                    </Button>
                </>
            }
        >
            <TextField variant="secondary" value={groupName} onChange={(e) => onGroupNameChange(e.target.value)} placeholder="Group name" autoFocus />
        </Modal>
    )
}
